module.exports = __webpack_public_path__ + "img/no_order_app.8985e9a.webp";